// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1IBYz","radioRow":"SimpleQuestionBuilderModal_radioRow__1UIhT"};